import { useEffect, useState } from 'react';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import PropTypes from 'prop-types';

// Lib
import { storiesSortTypes } from '@/lib/posts/postSortTypes';

// Components
import Select from '@/components/base/Select';

const ButtonSelectStoriesType = ({ error, disabled, selected, buttonTitle }) => {
    const { t } = useTranslation('myprofile');
    const btnTitle = buttonTitle ? buttonTitle : t('story_type');
    return (
        <Select.Button
            selected={selected}
            disabled={disabled}
            baseStyle="noBorder"
            error={error}
            sizeStyle={'sm'}>
            <div className="flex items-center space-x-3">
                <span className="block truncate text-icoBlack dark:text-white">
                    {`${btnTitle}: ${selected?.label}`}
                </span>
            </div>
        </Select.Button>
    );
};

const SelectStoriesType = ({ setRequestParams, buttonTitle }) => {
    const { t } = useTranslation('commons');
    const typeStoriesOptions = storiesSortTypes(t);
    const [activeType, setActiveType] = useState(typeStoriesOptions[0]);

    useEffect(() => {
        setRequestParams((prevState) => ({
            ...prevState,
            filter_post_type: activeType.value !== 'all' ? [activeType.value] : []
        }));
    }, [activeType, setRequestParams]);

    return (
        <Select
            selected={typeStoriesOptions.filter((item) => item.value === activeType.value)[0]}
            setSelected={setActiveType}
            options={typeStoriesOptions}
            noBorder
            button={<ButtonSelectStoriesType buttonTitle={buttonTitle} />}
        />
    );
};

SelectStoriesType.propTypes = {
    setRequestParams: PropTypes.func.isRequired
};

export default SelectStoriesType;
